// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"98f6d4d2","667":"f07b61bb","977":"23270789"}[chunkId] + ".chunk.js";
};